import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 28334 28334"
    {...props}
  >
    <defs>
      <style>
        {".str0{stroke:#000;stroke-width:313.985}.fil0{fill:#322d2c}"}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <path
        d="M27104 14167c0 7133-5804 12936-12938 12936-7133 0-12937-5803-12937-12936S7033 1230 14166 1230c7134 0 12937 5804 12938 12937zM14166 28177c7726 0 14011-6284 14011-14010 0-7725-6285-14010-14011-14010C6442 157 157 6442 157 14167c0 7726 6285 14010 14009 14010z"
        className="fill storke1"
        style={{
          strokeWidth: 313.985,
        }}
      />
      <path
        d="m9752 22449 3226-4337c621 340 1345 445 2038 294l2703 4886c-1296 509-4854 1545-7967-843zm5993-4940c-130-237-417-339-667-239-634 251-1357 136-1884-301-113-94-260-137-406-120-147 18-279 94-366 212l-3836 5159c-167 224-133 540 79 724 1840 1605 3853 2080 5591 2080 2501 0 4433-984 4465-1001 128-67 224-183 266-321s26-287-45-414l-3197-5779zM8053 6083l2768 4856c-489 513-776 1186-809 1894l-5383 497c-429-3942 2305-6412 3424-7247zm-4413 7919c45 259 270 445 529 445 16 0 33 0 50-2l6400-592c148-13 282-86 373-201 91-116 131-264 110-409-99-679 178-1355 722-1767 215-162 277-459 143-693L8696 5046c-72-126-192-217-331-254-140-36-289-15-412 60-54 32-5318 3279-4313 9150zM24276 13051l-5401-171c-76-703-404-1358-923-1841l2467-5010c1158 774 4039 3103 3857 7022zm-7293-1415c568 379 886 1037 828 1719-12 147 37 293 134 402 98 110 237 175 384 179l6426 203h16c272 0 504-205 534-478 647-5921-4805-8843-4860-8872-127-67-277-78-415-34-137 45-250 143-314 273l-2917 5924c-120 242-41 536 184 684zM14959 12301c431 122 788 403 1008 794 453 806 165 1828-640 2282-391 220-844 274-1274 152-431-121-790-403-1009-794-452-804-165-1828 640-2282 255-142 535-215 819-215 152 0 305 22 456 63zm-2850 2961c360 639 947 1102 1654 1300 247 69 497 104 746 104 466 0 926-120 1343-354 1322-743 1793-2422 1050-3744-359-639-947-1101-1654-1300-707-197-1449-109-2088 251-1322 742-1794 2421-1051 3743z"
        className="fill storke1"
        style={{
          strokeWidth: 313.985,
        }}
        
      />
    </g>
  </svg>
)
export default SvgComponent
